import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Footer from '../../components/Footer';
import InputField from '../../components/InputField';
import CalculationResultPart from '../../components/CalculationResultPart';
import { Helmet } from "react-helmet-async";
import { Link } from 'react-router-dom';
import LocalDatePicker from '../../components/LocalDatePicker';
import { IHBAR_VERGI_ARALIGI } from '../../constants/constants';
import { differenceInYears } from "date-fns";
import Header from '../../components/Header';

const faqs = [
    {
        question: "Belirsiz süreli iş sözleşmesi, işçi veya işverenin tek taraflı bir irade beyanı olarak fesih bildirimi ile sona erebilir. Belirsiz süreli iş sözleşmesinin feshinde taraflar ihbar sürelerine uymak zorundadır. Bu sürelere uyulmaması halinde usulsüz fesih söz konusu olur ve ihbar tazminatı gündeme gelir. Hem işçinin hem de işverenin iş akdini sona erdirmeden önce bildirimde bulunma yükümlülüğüne sahip olduğundan, İhbar tazminatı, hem işçi hem de işveren tarafından talep edilebilecek bir tazminat türüdür.",
    },
    {
        question: "Bildirim süresine uymayan taraf, bildirim süresine ilişkin ücret tutarında tazminat ödemek zorundadır. Bu tazminat, işçinin hazırlığı olmadan iş sözleşmesinin feshedilmesi halinde uğrayacağı maddi kaybın azaltılması anlamında işçiyi korur. İşveren bakımından ise, işçinin bildirim yapmadan iş sözleşmesinin feshi halinde işverenin yaşayacağı işgücü kaybı ve diğer olumsuzluklar karşısında işvereni korumaktadır.",
    },
    {
        question: "<h5>Kimler İhbar Tazminatı Alabilir?</h5>",
        answer: [
            "<strong>İşçi veya işveren tarafından yapılan fesih, haklı nedenle derhal fesih olmamalıdır.</strong> İş Kanunu belirli haller dahilinde bildirim süresi olmaksızın iş sözleşmesinin haklı nedenle derhal feshine imkan vermiştir. İşçi veya işverenin gerçekleştirdiği fesih haklı nedenle fesih niteliği taşıyorsa ihbar tazminatı söz konusu olmayacaktır. Haklı nedenle derhal fesih dışındaki bir sebeple belirsiz süreli iş sözleşmesini bildirim süresine uymaksızın sona erdiren işçinin veya işverenin karşı tarafa ihbar tazminatı ödeme yükümlülüğü bulunmaktadır.",
            "<strong>Belirsiz süreli iş sözleşmesi ile çalışan işçiler:</strong> Belirsiz süreli iş sözleşmeleri, işverenin veya işçinin herhangi bir nedenle feshedebileceği sözleşmelerdir. Bu tür sözleşmelerde, işveren iş akdini feshederse, işçiye ihbar tazminatı ödemek zorundadır.",
            "<strong>Deneme süresi dışında iş akdi feshedilen işçiler:</strong> Deneme süresi, işçinin ve işverenin birbirini tanıması için öngörülen bir süredir. Bu süre içerisinde iş akdi feshedilirse bile, işçiye ihbar tazminatı ödenmez. Deneme süresi bittikten sonra iş akdi feshedilirse, işçi ihbar tazminatı alma hakkına sahip olur.",
            "<strong>Mevsimlik işçiler (belirli koşullar altında):</strong> Mevsimlik işçiler, belirli mevsimlerde veya belirli işlerin yapılması için çalıştırılan işçilerdir. Bu tür işçiler de, iş akdinin feshi halinde belirli koşullar altında ihbar tazminatı alma hakkına sahip olabilir.",
            "<strong>Kısa süreli iş sözleşmesi ile çalışan işçiler (belirli koşullar altında):</strong> Kısa süreli iş sözleşmeleri, belirli bir süre için yapılan iş sözleşmeleridir. Bu tür sözleşmelerde de, işverenin feshi halinde işçiye ihbar tazminatı ödenebilir.",
        ]
    },
    {
        question: "<h5>Kimler İhbar Tazminatı Alabilir?</h5>",
        answer: [
            "<strong>Hesaplamaya esas süre:</strong> İşçinin işyerinde fiilen çalıştığı süredir. Bu süreye, hastalık, kaza, izin ve resmi tatiller gibi haklı gerekçelerle işe gelmediği günler de dahil edilir.",
            "<strong>Hesaplamaya esas ücret:</strong> İşçinin işten ayrıldığı zamanki brüt aylık ücretidir.",
            "<strong>İhbar tazminatı tutarı:</strong> Hesaplamaya esas sürenin, ihbar tazminatı süresine bölünmesi ile bulunur.",
        ]
    },
    {
        question: "<h5>İhbar Tazminatı Süresi:</h5>",
        answer: [
            "6 aydan az çalışmış işçiler için 2 hafta (14 gün)",
            "1,5 ile 3 yıl arası çalışmış işçiler için 6 hafta (42 gün)",
            "3 yıldan fazla çalışmış işçiler için 8 hafta (56 gün)",
        ]
    },
    {
        question: "<strong>Örnek:</strong>"
    },
    {
        question: "Bir işçi 5 yıl boyunca bir işverende çalışmış olsun ve son brüt aylık ücreti 15.000 TL olsun. Bu durumda, işçinin ihbar tazminatı tutarı şu şekilde hesaplanır:",
        answer: [
            "Hesaplamaya esas süre: 5 yıl",
            "Hesaplamaya esas ücret: 15.000 TL",
            "İhbar tazminatı süresi: 8 hafta",
            "İhbar tazminatı tutarı: (15.000/30)*8*7 : 28.000 TL",
        ]
    },
    {
        question: "<h5>İhbar Tazminatında Önemli Hususlar:</h5>",
        answer: [
            "<strong>İşveren ihbar süresinde işçisini çalıştırabilir mi?</strong><p>Evet, işveren ihbar tazminatı ödemek yerine, iş akdinin feshi bildirimini takiben ihbar süresince işçiyi çalıştırabilir. Bu durumda işçi çalışmaya devam etmek zorundadır.</p>",
            "<strong>Kıdem tazminatı ile ihbar tazminatı arasındaki fark nedir?</strong><p>Kıdem tazminatı, işçinin işyerinde çalıştığı her yıl için 30 günlük brüt ücretine tekabül eden bir tutardır. İş akdinin sona ermesi halinde, belirli şartlar sağlandığında işçiye ödenir. İhbar tazminatı ise, iş akdinin feshinde bildirim süresine uymayan işçinin veya işverenin ödemesi gereken tazminattır ve çalışma süresine göre hesaplanır.</p>",
            "<strong>İhbar tazminatına itiraz etme hakkı nedir?</strong><p>İşçi, kendisine ödenen ihbar tazminatının tutarının yanlış hesaplandığını düşünüyorsa, iş mahkemesine başvurarak tazminatın düzeltilmesini talep edebilir. Bu durumda işçi gerekli belgeleriyle birlikte dava açmalıdır.</p>",
        ]
    },
];

function calculateTax(income) {
    let totalTax = 0;

    for (let i = 0; i < IHBAR_VERGI_ARALIGI.length; i++) {
        const bracket = IHBAR_VERGI_ARALIGI[i];

        if (income > bracket.min) {
            const taxableIncome = Math.min(income, bracket.max) - bracket.min;
            totalTax += taxableIncome * bracket.rate;
        } else {
            break;
        }
    }

    return totalTax;
}

const IslahHarciHesaplama = () => {
    const [hideAll, setHideAll] = useState(false);
    const [results, setResults] = useState([]);
    const [calculated, setCalculated] = useState(false);

    const [iseGirisTarihi, setIseGirisTarihi] = useState(new Date());
    const [istenCikisTarihi, setIstenCikisTarihi] = useState(new Date());

    const [brutMaas, setBrutMaas] = useState(null);
    let [yolYemek, setYolYemek] = useState(null);

    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const query = new URLSearchParams(location.search);

        if (query.toString()) {
            const parsedResults = query.get('results');
            if (parsedResults) {
                setResults(JSON.parse(decodeURIComponent(atob(parsedResults))));
            }
            setIseGirisTarihi(new Date(decodeURIComponent(atob(query.get('iseGirisTarihi')))));
            setIstenCikisTarihi(new Date(decodeURIComponent(atob(query.get('istenCikisTarihi')))));
            setBrutMaas(Number(decodeURIComponent(atob(query.get('brutMaas')))));
            setYolYemek(Number(decodeURIComponent(atob(query.get('yolYemek')))));
            setCalculated(true);
        }

        localStorage.setItem('referrer', `${window.location.origin}${window.location.pathname}`);
    }, [location.search]);

    const calculate = () => {
        if (brutMaas) {
            if (iseGirisTarihi > istenCikisTarihi) {
                alert("İşe giriş tarihiniz işten çıkış tarihinizden sonra olamaz.");
                return;
            }
            if (yolYemek === null)
                yolYemek = 0;

            const hesaplanacak_deger = brutMaas + yolYemek;
            const yil_farki = Math.abs(
                differenceInYears(iseGirisTarihi, istenCikisTarihi)
            );

            const tazminat_gun =
                yil_farki < 0.5 ? 14 : yil_farki < 1.5 ? 28 : yil_farki < 3 ? 42 : 56;

            const ihbar_tazminati = (hesaplanacak_deger / 30) * tazminat_gun;
            const damga_vergisi_orani = 0.00759;
            const damga_vergisi_kesintisi = ihbar_tazminati * damga_vergisi_orani;
            const odenecek_ihbar = ihbar_tazminati - calculateTax(ihbar_tazminati) - damga_vergisi_kesintisi;

            const newResults = [
                { text: "Damga Vergisi Oranı", value: damga_vergisi_orani },
                { text: "Damga Vergisi Kesintisi", value: damga_vergisi_kesintisi },
                { text: "Ödenecek İhbar Tazminatı", value: odenecek_ihbar },
            ];

            setHideAll(true);

            const params = new URLSearchParams({
                results: btoa(encodeURIComponent(JSON.stringify(newResults))),
                iseGirisTarihi: btoa(encodeURIComponent(new Date(iseGirisTarihi).toISOString())),
                istenCikisTarihi: btoa(encodeURIComponent(new Date(istenCikisTarihi).toISOString())),

                brutMaas: btoa(encodeURIComponent(brutMaas.toString())),
                yolYemek: btoa(encodeURIComponent(yolYemek.toString())),
            });

            navigate(`${window.location.pathname}?${params.toString()}`);
            navigate(0);
        } else {
            alert("Lütfen tüm değerleri doğru girdiğinizden emin olunuz!");
        }
    };

    return (
        <>
            <Helmet>
                <title>İhbar Tazminatı Hesaplama - Legalbul</title>
                <link rel="canonical" href={`${window.location.origin}${window.location.pathname}`} />
                <meta name="description" content="İhbar tazminatı, fesih bildirimi için kanunda öngörülen ihbar süresine uymadan işi terk eden işçi veya aynı şekilde ihbar süresine uymadan işçinin işine son veren işverenin, ihbar süresine ilişkin ödeyeceği ücret tutarıdır." />
            </Helmet>

            <Header />
            <section className="container my-5 bg-white shadow-sm p-0">
                <div className="p-4">
                    <ol className="breadcrumbnav">
                        <li>
                            <Link to="/">Ana Sayfa</Link>
                        </li>
                        <li>
                            <Link to="/hesaplamalar">Tüm Hesaplamalar</Link>
                        </li>
                        <li>İhbar Tazminatı Hesaplama</li>
                    </ol>
                    <h1 className="fw-semibold">İhbar Tazminatı Hesapla</h1>
                    <p>İhbar tazminatı, fesih bildirimi için kanunda öngörülen ihbar süresine uymadan işi terk eden işçi veya aynı şekilde ihbar süresine uymadan işçinin işine son veren işverenin, ihbar süresine ilişkin ödeyeceği ücret tutarıdır.</p>

                    <LocalDatePicker label="İşe Giriş Tarihiniz" setValue={setIseGirisTarihi} value={iseGirisTarihi} />
                    <LocalDatePicker label="İşten Çıkış Tarihiniz" setValue={setIstenCikisTarihi} value={istenCikisTarihi} />

                    <InputField value={brutMaas} setValue={setBrutMaas} trailText="TL" label="Brüt Maaşınız" type="number" />
                    <InputField value={yolYemek} setValue={setYolYemek} trailText="TL" label="Yol Yemek Ücretiniz" type="number" />
                </div>

                <CalculationResultPart calculated={calculated} hideAll={hideAll} results={results} calculate={calculate} />
            </section>

            <Footer faqs={faqs} faqTitle="İhbar Tazminatı Hakkında Bilmeniz Gerekenler" />
        </>
    );
};

export default React.memo(IslahHarciHesaplama);
